<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import PersonalDetailsEditForm from '@/components/views/manage-account/PersonalDetailsEditForm.vue'
import RenewAuthorisationDeclaration from '@/components/dashboard/authorisation/RenewAuthorisationDeclaration.vue'
import PersonalDetailsLetterhead from '@/components/dashboard/shared/PersonalDetailsLetterhead.vue'
import { usePersonalDetailsDisplay } from '@/composables/usePersonalDetailsDisplay'

const store = useStore()
const { details } = usePersonalDetailsDisplay()

const renewStart = ref(true)
const addAddress = ref(false)
const addAuth = ref(false)

const enterAddress = () => {
  renewStart.value = false
  addAddress.value = true
  addAuth.value = false
}

const readAuth = () => {
  renewStart.value = false
  addAddress.value = false
  addAuth.value = true
}

const backToConfirm = () => {
  renewStart.value = true
  addAddress.value = false
  addAuth.value = false
}

onMounted(() => {
  store.commit('SET_LOADING', false)
})
</script>

<template>
  <div class="sa-stack sa-renew-flow" role="main">
    <section
      v-if="renewStart"
      class="sa-acct-section"
      aria-labelledby="renew-confirm-heading"
    >
      <h2 id="renew-confirm-heading">
        {{ $t('Dashboard.Settings.RenewAuth.Heading') }}
      </h2>
      <p class="sa-renew-flow__lead">
        {{ $t('Dashboard.Settings.RenewAuth.Lead') }}
      </p>

      <PersonalDetailsLetterhead
        v-if="details"
        variant="card"
        class="sa-renew-flow__details-card"
        :name-label="$t('Dashboard.Settings.Personal.FullName')"
        :address-label="$t('Dashboard.Settings.Personal.Address')"
        name-test-id="full-name"
        address-test-id="address"
      />

      <div class="sa-renew-flow__actions">
        <button type="button" class="sa-btn-primary" @click="readAuth">
          {{ $t('Buttons.Yes') }}
        </button>
        <button type="button" class="sa-btn-secondary" @click="enterAddress">
          {{ $t('Buttons.No') }}
        </button>
      </div>
    </section>

    <section
      v-else-if="addAddress"
      class="sa-acct-section"
      aria-labelledby="renew-address-heading"
    >
      <h2 id="renew-address-heading">
        {{ $t('Dashboard.Settings.Personal.Heading') }}
      </h2>
      <p class="sa-renew-flow__lead">
        {{ $t('Dashboard.Settings.RenewAuth.AddressLead') }}
      </p>

      <PersonalDetailsEditForm @saved="readAuth" @cancel-edit="backToConfirm" />

      <div class="sa-renew-flow__back">
        <button type="button" class="sa-btn-edit" @click="backToConfirm">
          {{ $t('Dashboard.Settings.RenewAuth.BackToConfirm') }}
        </button>
      </div>
    </section>

    <RenewAuthorisationDeclaration v-else-if="addAuth" />
  </div>
</template>
